import Layout from "./components/Layout/Layout";
// asdfasdfasdf

function App() {
  return <Layout />;
}

export default App;
